import { useEffect, useState } from 'react';
import { useAuthenticateUserQuery } from '../Apis/Common/authApi';
import { useNavigate } from 'react-router-dom';
import { MainLoader } from '../Components/Common';
import { rtkErrorRead } from '../Helper';
import { getAuthToken } from '../Helper/authToken';

const withLoggedIn = (WrappedComponent: any) => {
  return (props: any) => {
    const navigate = useNavigate();
    const token = getAuthToken();
    const [authenticate, setAuthenticate] = useState<boolean | null>(null); // Initially null
    const authUser = useAuthenticateUserQuery(null, {
      skip: !token, // Skip query if there's no token
    });

    useEffect(() => {
      if (!token) {
        setAuthenticate(false); // No token means not authenticated
        return;
      }

      if (authUser.isError) {
        rtkErrorRead(authUser.error);
        setAuthenticate(false);
      } else if (authUser.isSuccess) {
        setAuthenticate(authUser.data?.isSuccess ?? false);
      }
    }, [token, authUser.isError, authUser.isSuccess, authUser.data]);

    useEffect(() => {
      if (authenticate) {
        navigate('/', { replace: true });
      }
    }, [authenticate, navigate]);

    if (authUser.isLoading || authenticate === null) {
      return <MainLoader />; // Show loader while determining auth status
    }

    if (authenticate) {
      return null; // Prevent rendering before redirect
    }

    return <WrappedComponent {...props} />;
  };
};

export default withLoggedIn;
